import { ManageThreadsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const usePublishThread = () => {
  const [publishThread] = useAPIAction(
    ManageThreadsApi,
    async (api, threadId: string) => {
      let data = await api.threadsPublish({
        id: threadId,
      });
      return {
        successMessages: [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );
  return useCallback(
    async (threadId: string) => {
      return await publishThread(threadId);
    },
    [publishThread]
  );
};
